/**
 * The pure rules behind phone autolinking (ENG-3042) — kept free of ESM-only
 * remark imports so they can be unit-tested under ts-jest.
 *
 * US phone shapes only, and only with separators between the groups —
 * "(555) 123-4567", "555-123-4567", "+1 555.123.4567". A bare 10-digit run
 * (gate codes, unit numbers, confirmation IDs) must NOT become a phone link,
 * and the leading-boundary guard keeps digits inside URLs/paths untouched.
 *
 * `mdast-util-find-and-replace` requires the regex to be global.
 */
export const PHONE_RE = /(?<=^|[\s:;,(])((?:\+?1[-. ])?(?:\(\d{3}\)\s?|\d{3}[-. ])\d{3}[-. ]\d{4})(?=$|[\s.,;!?)])/g;

/** "(555) 123-4567" → "tel:+15551234567"; an 11-digit "+1 …" keeps its country code. */
export function phoneToTelHref(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  return digits.length === 10 ? `tel:+1${digits}` : `tel:+${digits}`;
}
